const Descriptions = {
  header: ['back', 'title', 'question', 'close'],
  top: ['operation-status', 'operation-history', 'add-point', 'other', 'asset-management'],
  courseSelection: ['current-point', 'profit-and-loss', 'go-to-detail', 'halfsheet-modal'],
  addPoint: ['current-point', 'available-point', 'input-point', 'added-point', 'auto-add-button'],
  addPointConfirmation: [
    'course-name',
    'spent-point',
    'add-point-group',
    'transaction-time',
    'added-point',
    'fee-group',
    'fee-percentage',
    'fee-value',
  ],
  addPointCompletion: [
    'question-button',
    'close-button',
    'transaction-time',
    'point',
    'add-complete',
    'course-name',
    'paypay-point',
    'add-point-group',
    'commission-time',
    'added-point',
    'fee-group',
    'fee-percentage',
    'fee-value',
  ],
  history: ['course-name', 'operation-time', 'transaction-point', 'course-group'],
  autoAdd: ['tick'],
  modal: ['general-course', 'no-account', 'no-points', 'use-cashback', 'crypto-transaction-rule'],
} as const

export type Screen = keyof typeof Descriptions

type Element = 'text' | 'button' | 'element' | 'icon' | 'input'

export const generateTestId = <S extends Screen>(
  screen: S,
  elementType: Element,
  description: (typeof Descriptions)[S][number],
) => {
  return `${screen}-${elementType}-${description}` as const
}
